import { companyTeamMemberConnection as schema } from 'store/common/schemas';
import { createEntitiesReducer, createEntitiesSelector } from './helpers';

import * as userTeamMembershipActionTypes from 'store/features/users/team-memberships/action-types';

export const reducer = createEntitiesReducer(schema, (state, action) => {
  switch (action.type) {
    case userTeamMembershipActionTypes.REJECT_TEAM_MEMBERSHIP.SUCCESS:
      const { teamMembershipId: rejectedTeamMembershipId } = action.payload;
      return rejectedTeamMembershipId
        ? state.merge(
            {
              [rejectedTeamMembershipId]: { rejectedTimestamp: new Date().toISOString() },
            },
            { deep: true }
          )
        : state;
    case userTeamMembershipActionTypes.POLL_TEAM_MEMBERSHIP.START:
      const { teamMembershipId: pollingTeamMembershipId } = action.payload;
      return pollingTeamMembershipId
        ? state.merge(
            {
              [pollingTeamMembershipId]: { polling: true },
            },
            { deep: true }
          )
        : state;
    case userTeamMembershipActionTypes.POLL_TEAM_MEMBERSHIP.STOP:
      const { teamMembershipId: polledTeamMembershipId } = action.payload;
      return polledTeamMembershipId
        ? state.merge(
            {
              [polledTeamMembershipId]: { polling: false },
            },
            { deep: true }
          )
        : state;
    default:
      return state;
  }
});

export const selector = createEntitiesSelector(schema);



// WEBPACK FOOTER //
// ./src/store/entities/company-team-member-connections.js